import { ROVER_HOSTS } from '@rover/constants/src/platform/hosts.constants';
import { SERVICE_LANDING_REGEX } from '@rover/constants/src/platform/routeData.constants';
import { SEO_LOCATION_REGEX } from '@rover/utilities/seoRegex';

export function getReferrerIsRover(url): boolean {
  return ROVER_HOSTS.test(url?.hostname ?? '');
}

export function getReferrerIsSeoLanding(url): boolean {
  if (!url) return false;
  return (
    getReferrerIsRover(url) &&
    (SERVICE_LANDING_REGEX.test(url.pathname ?? '') ||
      SEO_LOCATION_REGEX.ALL_SEO_CITY_AND_NEIGHBORHOOD_SERVICE.test(url.pathname ?? ''))
  );
}
